import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

/** A value with a small copy button (ids, phone numbers, references). */
export default function CopyValue({ value, display, mono = false }: { value: string; display?: React.ReactNode; mono?: boolean }) {
  const [copied, setCopied] = React.useState(false);
  const copy = async (event: React.MouseEvent) => {
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1400);
    } catch {
      /* clipboard blocked; nothing to do */
    }
  };
  return (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.25, minWidth: 0, maxWidth: "100%" }}>
      <Box component="span" className={mono ? "mono" : undefined} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {display ?? value}
      </Box>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <IconButton size="small" onClick={copy} aria-label={`Copy ${value}`} sx={{ p: 0.5, color: copied ? "success.main" : "text.secondary" }}>
          {copied ? <CheckIcon sx={{ fontSize: 15 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
